import { pushPlayerAction } from 'services/actionlog.service';
import { User } from 'types/user';

import { BehaviorKey } from './recognition';
import { MAX_MESSAGE_LENGTH, MIN_MESSAGE_LENGTH, MessageContent } from './recognition-message';
import { Cycle } from './recognition-phase';
import { CoinKey, coinIsAvailable } from './recognition-points';
import { Step } from './recognition-steps';

/** O retrato do fluxo que acompanha cada registro do log (REC-59). */
export type RecognitionLogState = {
  step: Step;
  sending: boolean;
  /** Saldo `point_behavior` de quem envia, como veio do servidor. */
  balance?: number;
  pointsSent: number;
  target?: User;
  behavior?: BehaviorKey;
  coin?: CoinKey;
  points?: number;
  message?: MessageContent;
  cycle: Cycle;
};

/** Data do ciclo no formato que o log espera: `{ $date }` quando vem como número. */
function loggedDate(value: unknown) {
  if (!value) return 'ND';

  return typeof value === 'number' ? { $date: value } : value;
}

/** Registra uma ação da pessoa no log `partialRewardBehavior`. Falha de log não interrompe o fluxo. */
export function logRecognitionAction(action: Record<string, unknown>, state: RecognitionLogState) {
  const balance = state.balance || 0;

  try {
    pushPlayerAction('partialRewardBehavior', {
      data: {
        action,
        step: state.step,
        hasEnoughCoins: {
          uau: coinIsAvailable('uau', balance, state.pointsSent),
          mandou: coinIsAvailable('mandou', balance, state.pointsSent),
          valeu: coinIsAvailable('valeu', balance, state.pointsSent),
          point_behavior: state.balance || 'ND',
        },
        loading: state.sending,
        target: state.target?._id || 'ND',
        behavior: state.behavior || 'ND',
        coin: state.coin || 'ND',
        points: state.points !== undefined ? state.points : 'ND',
        pointsSent: state.pointsSent,
        message: state.message?.html || 'ND',
        messageLength: state.message?.length || 'ND',
        minTextLength: MIN_MESSAGE_LENGTH,
        maxTextLength: MAX_MESSAGE_LENGTH,
        stage: {
          status: state.cycle?.status || 'ND',
          date_start: loggedDate(state.cycle?.date_start),
          date_finish: loggedDate(state.cycle?.date_finish),
        },
      },
    });
  } catch (error) {}
}
